/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiModelsView,
  WebApiViewDtoCreateViewDto,
  WebApiViewDtoUpdateViewDto,
} from '../models';
import {
    WebApiModelsViewFromJSON,
    WebApiModelsViewToJSON,
    WebApiViewDtoCreateViewDtoFromJSON,
    WebApiViewDtoCreateViewDtoToJSON,
    WebApiViewDtoUpdateViewDtoFromJSON,
    WebApiViewDtoUpdateViewDtoToJSON,
} from '../models';

export interface ApiViewIdDeleteRequest {
    id: number;
}

export interface ApiViewIdPutRequest {
    id: number;
    webApiViewDtoUpdateViewDto?: WebApiViewDtoUpdateViewDto;
}

export interface ApiViewPostRequest {
    webApiViewDtoCreateViewDto?: WebApiViewDtoCreateViewDto;
}

/**
 * 
 */
export class ViewApi extends runtime.BaseAPI {

    /**
     */
    async apiViewGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiModelsView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/View`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiModelsViewFromJSON));
    }

    /**
     */
    async apiViewGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiModelsView>> {
        const response = await this.apiViewGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiViewIdDeleteRaw(requestParameters: ApiViewIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiViewIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/View/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiViewIdDelete(requestParameters: ApiViewIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiViewIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiViewIdPutRaw(requestParameters: ApiViewIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiModelsView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiViewIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/View/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiViewDtoUpdateViewDtoToJSON(requestParameters.webApiViewDtoUpdateViewDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiModelsViewFromJSON(jsonValue));
    }

    /**
     */
    async apiViewIdPut(requestParameters: ApiViewIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiModelsView> {
        const response = await this.apiViewIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiViewPostRaw(requestParameters: ApiViewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiModelsView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/View`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiViewDtoCreateViewDtoToJSON(requestParameters.webApiViewDtoCreateViewDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiModelsViewFromJSON(jsonValue));
    }

    /**
     */
    async apiViewPost(requestParameters: ApiViewPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiModelsView> {
        const response = await this.apiViewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
